// extracted by mini-css-extract-plugin
export default {"wrapper":"jea-z","boldPrefix":"kea-z","link":"lea-z","message":"mea-z","image":"nea-z"};